module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var constants = require('Constants.js').default;

    ; __append("\r\n\r\n<div class=\"page-title\">\r\n    <div class=\"row\">\r\n        <div class=\"col col-sm-12 col-lg-12\">\r\n            <h1>Settings Dashboard</h1>\r\n        </div>\r\n    </div>\r\n    <ol class=\"breadcrumb\">\r\n        <li class=\"active\">Settings</li>\r\n    </ol>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col col-sm-12\">\r\n        <h2>Information</h2>\r\n        <div class=\"panel panel-default\" style=\"border: 0; box-shadow: none; height:auto;\">\r\n            <div class=\"panel-body\" style=\"padding: 0;\">\r\n                <span class=\"info-settings\"> \r\n                    <p>Settings allow you to manage global and personal account settings and monitor account usage according to license parameters.</p>\r\n                    \r\n                    <p>\r\n                    Any person who wants to log in needs to be registered as a user. You can administer users through Account Settings.\r\n                    User-groups and positions allow apps to be routed dynamically between people and departments. \r\n                    Each user can be granted different log in rights and access permissions.\r\n                    </p>\r\n                    <p>\r\n                    Administer your email servers for sending notifications and your custom lists, to be used in apps and reports, in Account Settings.\r\n                    </p>\r\n                    \r\n                </span>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div class=\"row\">\r\n    <div class=\"col col-sm-12\"><h2>Settings Help</h2></div>\r\n</div>\r\n\r\n<div class=\"row\">\r\n    <div class=\"col-md-11\">\r\n        <a target=\"_blank\" rel=\"help\"\r\n           href=\"")
    ; __append(escapeFn(constants.HELP_ACC_SETTINGS ))
    ; __append("\">Account\r\n            Settings</a></br>\r\n        <a target=\"_blank\" rel=\"help\"\r\n           href=\"")
    ; __append(escapeFn(constants.HELP_ADMIN_USERS ))
    ; __append("\">Administering\r\n            Users, User Groups, and Positions.</a></br>\r\n        <a target=\"_blank\" rel=\"help\"\r\n           href=\"")
    ; __append(escapeFn(constants.HELP_ADD_ACCOUNT ))
    ; __append("\">Adding Account\r\n            Resources.</a></br>\r\n    </div>\r\n</div>")
  }
  return __output;

}